export default "__VITE_ASSET__BHC_M5WT__"